var _path, _g, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0026 16.9231C17.0026 12.9474 12.584 11.5237 10.9702 15.1571C9.11899 19.3248 8 23.6002 8 26.8988C8 36.3436 15.9503 44 25.2185 44C34.4867 44 42 36.3436 42 26.8988C42 13.7166 35.7103 0 26.4422 0C24.9615 0 23.9949 1.39824 23.9949 2.87886V16.9231C23.9949 18.8908 22.4296 20.4858 20.4987 20.4858C18.5678 20.4858 17.0026 18.8908 17.0026 16.9231Z",
    fill: "#ED6011"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1082_1924)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0283 32C28.0283 30.0225 30.2002 29.3237 30.9524 31.1526C31.611 32.7542 32 34.351 32 35.6154C32 39.6938 28.4925 43 24.4036 43C20.3147 43 17 39.6938 17 35.6154C17 29.9231 19.7749 24 23.8638 24C24.5157 24 24.9434 24.6137 24.9434 25.2657V32C24.9434 32.8497 25.634 33.5385 26.4859 33.5385C27.3377 33.5385 28.0283 32.8497 28.0283 32Z",
    fill: "#714A08"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_1082_1924)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4987 30.8421C28.4987 28.6303 30.9316 27.8289 31.7955 29.865C32.5524 31.6488 33 33.4299 33 34.8381C33 39.3458 29.0248 43 24.3907 43C19.7567 43 16 39.3458 16 34.8381C16 28.5466 19.1448 22 23.7789 22C24.5162 22 25.0026 22.6915 25.0026 23.4288V30.8421C25.0026 31.7812 25.7852 32.5425 26.7506 32.5425C27.7161 32.5425 28.4987 31.7812 28.4987 30.8421Z",
    fill: "#FEC76A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.47703C19 9.87043 17.6569 11 16 11C14.3431 11 13 9.87043 13 8.47703C13 7.08363 13.4 2.7583 16 3.01059C19 3.01059 19 7.08363 19 8.47703Z",
    fill: "#ED6011"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1082_1924",
    x: 13,
    y: 20,
    width: 23,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1082_1924"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_1082_1924",
    x: 10.4,
    y: 16.4,
    width: 28.2,
    height: 32.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1082_1924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1082_1924",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.86667,
    dy: 1.86667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.187 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1082_1924"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.86667,
    dy: -1.86667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.76 0 0 0 0 0.76 0 0 0 0 0.76 0 0 0 0.187 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1082_1924",
    result: "effect3_innerShadow_1082_1924"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.0ce9f0dd73789728200077aea452f3eb.svg";
export { ForwardRef as ReactComponent };